var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-bottom"},[_c('p',[_c('a',{staticClass:"footer-link",attrs:{"href":""}},[_vm._v("©2023 "+_vm._s(_vm.sInfo.site_name)+". All Rights Reserved.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }